<template>
  <el-container class="layout-root">
    <AdminSidebar />
    <el-container direction="vertical" class="layout-main-wrap">
      <AppHeader />
      <el-main class="layout-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AdminSidebar from './AdminSidebar.vue'
import AppHeader from './AppHeader.vue'

export default {
  name: 'AdminLayout',
  components: { AdminSidebar, AppHeader }
}
</script>

<style lang="scss" scoped>
.layout-root {
  min-height: 100vh;
  background: #0b0e1e;
}

.layout-main-wrap {
  min-width: 0;
  background: #0b0e1e;
}

.layout-main {
  padding: 8px 28px 32px;
  min-height: calc(100vh - 64px);
  background: #0b0e1e;
}
</style>
